module.exports = __webpack_public_path__ + "static/media/logo-projekta-seal.6761696e.svg";